import React, { useEffect, useState } from 'react';
import InfoIconComponent from '../../InfoIcon';
import style from './EntryTacticsModules.module.css';
import PropTypes from 'prop-types';
import MarketOrderDocs from '../../../../documentation/MarketOrderDocumentation';
import NumberInputWithUnit from '../../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';

function MarketOrderModule({ state, top }) {
  const [
    marketOrder,
    dispatchMarketOrder,
    ,
    setMarketOrderEnabled,
  ] = state;
  const [amountDisplay, setAmountDisplay] = useState('');

  useEffect(() => {
    setMarketOrderEnabled(true);
  }, []);

  useEffect(() => {
    setAmountDisplay(marketOrder.quantityBasisValue ?? 0);
  }, [marketOrder]);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={MarketOrderDocs} /> Market Order
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p>{top.quantityBasis === 'DOLLARS' ? 'Dollar' : 'Qty.'} Amount</p>
          <NumberInputWithUnit
            inputWidth="5em"
            direction="left"
            type="number"
            value={amountDisplay}
            setValue={setAmountDisplay}
            onBlur={(value) => dispatchMarketOrder({ quantityBasisValue: value })}
          >
            {top.quantityBasis === 'DOLLARS' ? '$' : '#'}
          </NumberInputWithUnit>
        </div>
      </div>
    </div>
  );
}
MarketOrderModule.propTypes = {
  state: PropTypes.array.isRequired,
  top: PropTypes.object.isRequired
};
export default MarketOrderModule;
